namespace $.$$ {
	export class $shm_knowledge extends $.$shm_knowledge {
		override arg( spread: string ) { return { ...super.arg( spread ), help: 'off' } }
		@ $mol_mem_key
		override Menu_link( spread: string ) {
			const link = super.Menu_link( spread )
			link.current = ()=> ( this.spread() || 'guide' ) === spread
			return link
		}
		@ $mol_mem
		override Menu() {
			const page = super.Menu()
			page.head = ()=> [ page.Title(), this.Help(), page.Tools() ]
			return page
		}
		knowledge_api_url() {
			return this.$.$shm_projects_config.projects_api_url()
		}

		knowledge_api_headers() {
			const token = this.$.$shm_projects_config.agent_token()
			return token ? { 'X-Hitalama-Agent-Token': token } : {}
		}

	}
}
